import React from 'react';
import PropTypes from 'prop-types';

import { StyledButton, Loading, LoadingWrapper } from './styled';

const Button = ({
  type = 'button',
  children,
  color,
  onClick,
  mr,
  ml,
  mt,
  mb,
  p,
  flex,
  maxW,
  loading,
  disabled,
  width,
  isCancel,
  height,
  ...rest
}) => {
  return (
    <StyledButton
      height={height}
      disabled={loading || disabled}
      as={loading ? 'div' : 'button'}
      type={type}
      color={color}
      p={p}
      onClick={onClick}
      ml={ml}
      mr={mr}
      mt={mt}
      mb={mb}
      flex={flex}
      isCancel={isCancel}
      loading={loading ? 1 : undefined}
      maxW={maxW}
      width={width}
      {...rest}
    >
      {loading ? <Loading /> : children}
    </StyledButton>
  );
};

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  color: PropTypes.oneOf([
    'primary',
    'action',
    'cancel',
    'primary_light',
    'primary_white',
    'danger',
  ]),
  onClick: PropTypes.func,
  mr: PropTypes.number,
  ml: PropTypes.number,
  mt: PropTypes.number,
  mb: PropTypes.number,
  p: PropTypes.string,
  maxW: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.oneOf(['button', 'submit']),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Button;
